var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "utekoll_2",
    "data-name": "utekoll 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "760 180 410 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 951.6,
    y1: 534.69,
    x2: 965.16,
    y2: 534.69,
    gradientTransform: "translate(72.06 -144.66) rotate(8.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5a7aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 933.36,
    y1: 338.81,
    x2: 992.11,
    y2: 338.81,
    gradientTransform: "translate(72.06 -144.66) rotate(8.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f80a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#839bb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d80a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 944.73,
    y1: 478.84,
    x2: 974.75,
    y2: 478.84,
    gradientTransform: "translate(72.06 -144.66) rotate(8.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e19e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e9b883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e19e4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 940.12,
    y1: 220.2,
    x2: 992.11,
    y2: 220.2,
    gradientTransform: "translate(72.06 -144.66) rotate(8.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e19e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#e8b783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#e19e4d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1034.68,241.56c52.62,25.55,88.9,79.5,88.9,141.93,0,84.7-66.78,153.8-150.56,157.53-2.36.11-4.74.16-7.13.16-21.77,0-42.51-4.41-61.38-12.39-56.6-23.94-96.31-79.98-96.31-145.29,0-81.42,61.71-148.42,140.9-156.8",
    fill: "none",
    opacity: 0.6,
    stroke: "#6785a6",
    strokeMiterlimit: 10,
    strokeWidth: 60
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1123.37,390.61c-3.98,81.07-69.2,146.05-150.36,149.66-2.36.11-4.74.16-7.13.16-21.77,0-42.51-4.41-61.38-12.39-56.6-23.94-96.31-79.98-96.31-145.29,0-18.56,3.21-36.37,9.1-52.91",
    fill: "none",
    stroke: "#008043",
    strokeMiterlimit: 10,
    strokeWidth: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "isdubb_copy_2",
    "data-name": "isdubb copy 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "spets",
    points: "943.23 473.86 930.06 547.07 928.78 579.03 930.4 579.27 942.42 546.09 954.56 475.57 943.23 473.86",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "spetsbl\\xE4nk",
    points: "947.85 474.56 940.63 514.61 931.25 547.01 930.09 576.63 941.2 545.44 943.09 515.22 950.43 474.71 947.85 474.56",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl\\xE5tt_handtag",
    "data-name": "bl\\xE5tt handtag",
    d: "m934.38,472.89c-.18-.08.06-.39.11-.6,10.47-41.07,1.45-47.23-2.36-56.89,0,0-1.64-.8,1.19-4.77,14.89-20.95,13.34-20.31,14.34-62.54.84-35.2,14.4-84.39,28.87-115.99,5.02-17.6-6.82-26.46-5.78-31.66,1.03-5.2,1.83-9.17,1.83-9.17,8.55-4.66,26.29-1.13,26.29-1.13,0,0,18.04,2.75,24.51,10.03,0,0-.6,4.01-1.4,9.25-.79,5.24-14.94,9.57-16.18,27.83,2.89,34.64-1.04,85.51-12.18,118.91-13.37,40.07-14.62,38.94-7.72,63.7,1.31,4.7-.5,4.89-.5,4.89-6.85,7.79-17.43,10.53-21.51,52.72-.02.21.09.59-.1.6-12.98,1.2-17.61.37-29.41-5.17Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "band",
    d: "m964.88,468.85c-.36,2.67-.69,5.53-.99,8.6-.02.21.09.59-.1.6-12.98,1.2-17.61.37-29.41-5.17-.18-.08.06-.39.11-.6.76-2.98,1.42-5.77,1.98-8.4,0,0,10.18,3.72,13.71,4.34,3.61.64,14.7.62,14.7.62Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "knopp",
    d: "m973.42,239.19c1.03-2.45,2.07-4.82,3.11-7.1,5.02-17.6-6.82-26.46-5.78-31.66,1.03-5.2,1.83-9.17,1.83-9.17,8.55-4.66,26.29-1.13,26.29-1.13,0,0,18.04,2.75,24.51,10.03,0,0-.6,4.01-1.4,9.25-.79,5.24-14.94,9.57-16.18,27.83.23,2.81.42,5.72.57,8.73,0,0-12.75-.88-16.76-1.71-4.22-.87-16.18-5.06-16.18-5.06Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kontur",
    d: "m934.38,472.89c-.18-.08.06-.39.11-.6,10.47-41.07,1.45-47.23-2.36-56.89,0,0-1.64-.8,1.19-4.77,14.89-20.95,13.34-20.31,14.34-62.54.84-35.2,14.4-84.39,28.87-115.99,5.02-17.6-6.82-26.46-5.78-31.66,1.03-5.2,1.83-9.17,1.83-9.17,8.55-4.66,26.29-1.13,26.29-1.13,0,0,18.04,2.75,24.51,10.03,0,0-.6,4.01-1.4,9.25-.79,5.24-14.94,9.57-16.18,27.83,2.89,34.64-1.04,85.51-12.18,118.91-13.37,40.07-14.62,38.94-7.72,63.7,1.31,4.7-.5,4.89-.5,4.89-6.85,7.79-17.43,10.53-21.51,52.72-.02.21.09.59-.1.6-12.98,1.2-17.61.37-29.41-5.17Z",
    fill: "none",
    stroke: "#808285",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUk);
export default __webpack_public_path__ + "static/media/logoUk.00a889252ad420daef2e88de51e1f5bc.svg";
export { ForwardRef as ReactComponent };